var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddedToCart = function SvgAddedToCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeWidth: 1.4,
    d: "M5.5 19.353A9.954 9.954 0 0 0 11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11a9.955 9.955 0 0 0 1.647 5.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#102262",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m8 11 2 2 4-4"
  })));
};
export default SvgAddedToCart;